import { getData, getMobileServiceName } from './utils';
import { trackCancelClick, trackConfirmClick, trackModalShow } from './PackageBuyConfirmationModal.tracking';
import './blocks/Desktop.css';
import './blocks/Mobile.css';
import { selectActiveRecommendedPackage } from '../../../../../shared/selectors/publishTerms';

export function PackageBuyConfirmationModalController(
  $scope,
  deviceService,
  store,
  placingTermsApi,
  popupService,
  $uibModalInstance,
  publishTermsService,
) {
  'ngInject';

  const state = store.getState();

  let { selectedPeriod } = placingTermsApi.selected.option;

  if (publishTermsService.isNewPublishTermsEnabled()) {
    selectedPeriod = selectActiveRecommendedPackage(state);
  }

  trackModalShow();

  $scope.isMobile = deviceService.isMobile;
  $scope.data = getData(selectedPeriod, state);

  $scope.getMobileServiceName = getMobileServiceName;

  $scope.cancel = () => {
    trackCancelClick();

    $uibModalInstance.dismiss();
  };

  $scope.confirm = () => {
    trackConfirmClick(this.autoProlong);

    $uibModalInstance.close();

    $uibModalInstance.closed.then(() => {
      popupService.openPopup('PackageBuyResultModal', {
        settings: {
          autoProlong: this.autoProlong,
        },
      });
    });
  };
}
